import axios, { AxiosResponse } from "axios";
import environment from "../config";
import SalaryData from "../entities/SalaryData";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";

export async function GetSalaryData(
  _fundCode?: number,
  _salaryFromDate?: string,
  _salaryToDate?: string
) {
  try {
    const body = {
      fundCode: _fundCode ? _fundCode : null,
      salaryFromDate: _salaryFromDate ? _salaryFromDate : "",
      salaryToDate: _salaryToDate ? _salaryToDate : "",
    };
    const path = environment.BASE_URL + "MemberDataWareHouse/GetSalaryData";
    const res: AxiosResponse<any> = await dal.post(path, body);
    if (axiosUtil.isSuccess(res) && res?.data?.dataRows?.length) {
      const salaryData = res.data.dataRows;
      return salaryData.sort((a: SalaryData, b: SalaryData) => {
        return (
          new Date(b.salaryDate).valueOf() - new Date(a.salaryDate).valueOf()
        );
      });
    }
    return [];
  } catch (err) {
    console.log(err);
  }
}
